import { CyclingEvent } from './types';

/**
 * „Beliebt" ist abgeleitet, kein Handschalter (Trello d0h5p6Eb, docs/bereiche/beliebt.md).
 *
 * Zwei Wege, ein Badge: entweder haben sich genug Nutzer das Event gemerkt, oder der
 * Veranstalter nennt eine Teilnehmerzahl der letzten Auflage, die für sich spricht. Die Schwellen
 * stehen hier einmal für Web und App; wer sie ändert, ändert sie für beide.
 */
export const POPULAR_MIN_FAVORITES = 10;
export const POPULAR_MIN_PARTICIPANTS = 500;

/** Beschriftung des Badges, auf Card und Detailseite dieselbe. */
export const POPULAR_LABEL = 'Beliebt';

export function isPopularEvent(
  event: Pick<CyclingEvent, 'favoriteCount' | 'participants'>
): boolean {
  return (event.favoriteCount ?? 0) >= POPULAR_MIN_FAVORITES
    || (event.participants ?? 0) >= POPULAR_MIN_PARTICIPANTS;
}

/** „1.200" — Tausenderpunkt wie im Deutschen üblich, ohne Intl (shared kompiliert gegen es2018). */
export function formatParticipants(count: number): string {
  return String(Math.trunc(count)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}
